import { render, staticRenderFns } from "./ProjectVersions.vue?vue&type=template&id=37621fd9&lang=pug&"
import script from "./ProjectVersions.vue?vue&type=script&lang=js&"
export * from "./ProjectVersions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersions.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports